import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteAdmin } from 'api/admin.service';
import { clearPermissionStore } from 'store/permission.store';
import { AxiosError } from 'axios';
import { useToast } from 'hooks/ui';

export const useAdminDeleteQuery = () => {
  const toast = useToast();
  const queryClient = useQueryClient();

  const { isLoading, mutate } = useMutation(
    ({ id }: { id: string }) => deleteAdmin(id),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['admins']);
        clearPermissionStore();
        toast.success('Admin has been deleted successfully');
      },
      onError: (error: AxiosError) => {
        toast.error(error.message);
      },
    },
  );

  return { isLoading, mutate };
};
